<div class="landing-background" *ngIf="env && env != 'production'">
    <div class="pt-2 d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        <div class="p-4">
            <img class="" src="/assets/img/logo.png" alt="LOGO"  />
        </div>

        <div class="tagline ">
            <h5 class="text-weight-bold tagline-color">
                World’s Most Reliable Certification Manager for
                <i>Competitive</i> Professionals
            </h5>
        </div>
    </div>
    <div class="container text-center">
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="mt-5">
                    <h1 style="font-size: 6em;">STAY ON <span style="font-size: 0.3em;">TRACK</span> & STAY <span style="font-size: 0.3em;">AHEAD</span></h1>
                    <p class="text-weight-bold text-white mt-5 mb-5" style="font-size: 1.7em; line-height: 30px;" >
                        CertWallet is your personal cheat code towards keeping your
                        certifications alive. CertWallet automates certification renewal for
                        career professionals.
                    </p>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center" style="gap: 10px;">
            <button class="landing-button btn"  (click)="login()">
                    <mat-icon>login</mat-icon>&nbsp;Sign in
            </button>
            <button class="landing-button btn" [routerLink]="'/register'">
                <mat-icon>chevron_right</mat-icon> Create Wallet
            </button>
        </div>
        <div class="mt-5">
            <img class="img-fluid" src="./assets/img/Group-214.png" alt="" />
        </div>
    </div>
</div>




